import PropTypes from 'prop-types';
import Button from './Button';
import Modal from './Modal';

function ConfirmModal({ open, title, message, onConfirm, onCancel }) {
  if (!open) {
    return null;
  }
  return (
    <Modal>
      <Modal.Title title={title} />
      <Modal.Message message={message} />
      <Modal.ButtonRow>
        <Button type="cancel" onClick={onCancel} message="Cancel" />
        <Button type="delete" onClick={onConfirm} message="Delete" />
      </Modal.ButtonRow>
    </Modal>
  );
}
ConfirmModal.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};
export default ConfirmModal;
